import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion"; 
import api from "../api/api";

const shakeAnimation = {
  x: [0, -10, 10, -10, 10, 0], 
  transition: { 
      duration: 0.4, 
      type: "tween",
      ease: "easeInOut"
  },
};

const inputStyle = {
  padding: "12px",
  marginTop: "2px",
  marginBottom: "2px",
  borderRadius: "8px",
  border: "1px solid #ccc",
};

export default function Register() {
  const navigate = useNavigate();

  // 🔒 Bloquear scroll y ajustar altura
  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.style.height = "100vh";
    return () => {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    };
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "trabajador",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false); // Estado de carga
  const [vibrationKey, setVibrationKey] = useState(0); 
  const [isExiting, setIsExiting] = useState(false);

  const handleGoToLogin = () => {
    setIsExiting(true);
    setTimeout(() => {
      navigate("/login");
    }, 600);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (loading) return; 

    console.log("1. 🚀 Intento de registro iniciado");
    setError("");
    setSuccess("");
    setLoading(true); // Bloqueamos el botón y el form

    try {
      console.log("2. 📡 Enviando datos a Railway...");
      const res = await api.post("/auth/register", formData);
      
      console.log("3. ✅ Registro exitoso:", res.data);
      setSuccess(res.data.message || "✅ Registro exitoso");
      // No reseteamos loading aquí porque queremos que el botón desaparezca al mostrar el éxito
    } catch (err) {
      console.error("4. ❌ Error atrapado:", err);
      setError(err.response?.data?.message || "Error al registrar el usuario.");
      setVibrationKey(prev => prev + 1);
      setLoading(false); 
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        background: "#FAFAFA",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Link
        to="/"
        style={{
          position: "absolute",
          top: 20,
          left: 20,
          color: "#00796B",
          fontWeight: "600",
          textDecoration: "none",
          fontSize: "16px",
          padding: "6px 10px",
          borderRadius: "6px",
        }}
      >
        ← Volver al inicio
      </Link>

      <motion.div
        key={vibrationKey}
        initial={{ y: -50, opacity: 0 }}
        animate={
          isExiting
            ? { y: 200, opacity: 0, x: 0 }
            : error
            ? { y: 0, opacity: 1, x: shakeAnimation.x }
            : { y: 0, opacity: 1, x: 0 }
        }
        transition={
          isExiting
            ? { duration: 0.5, ease: "easeIn" }
            : { y: { duration: 0.5, ease: "easeOut" }, x: shakeAnimation.transition }
        }              
        style={{
          display: "flex",
          flexDirection: "column",
          width: "380px",
          padding: "30px",
          background: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
          borderTop: "5px solid #00796B",
        }}
      >
        <h2 style={{ textAlign: "center", color: "#00796B", marginBottom: "5px" }}>
          {success ? "¡Casi listo!" : "Crear cuenta"}
        </h2>

        {success ? (
          <div style={{ textAlign: 'center', padding: '10px' }}>
            <div style={{ fontSize: '50px', marginBottom: '10px' }}>📧</div>
            <p style={{ color: "#333", fontWeight: "600", lineHeight: "1.5" }}>
              Hemos enviado un correo a tu casilla.<br/>
              <span style={{ color: "#00796B" }}>Verificá tu cuenta para poder continuar.</span>
            </p>
            <button 
              onClick={handleGoToLogin}
              style={{
                marginTop: "20px",
                padding: "12px 25px",
                background: "#00796B",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
                cursor: "pointer",
                width: "100%"
              }}
            >
              Entendido, ir al Login
            </button>
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column" }}>
              <label style={{ fontWeight: "600", color: "#333", marginTop: "15px" }}>Nombre</label>
              <input
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={loading} // Bloqueado si carga
                style={{ ...inputStyle, background: loading ? "#f0f0f0" : "white" }}
              />
              <label style={{ fontWeight: "600", color: "#333", marginTop: "15px" }}>Email</label>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
                style={{ ...inputStyle, background: loading ? "#f0f0f0" : "white" }}
              />

              <label style={{ fontWeight: "600", color: "#333", marginTop: "15px" }}>Contraseña</label>
              <input
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
                style={{ ...inputStyle, background: loading ? "#f0f0f0" : "white" }}
              />

              <label style={{ fontWeight: "600", color: "#333", marginTop: "15px" }}>Tipo de usuario</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                disabled={loading}
                style={{
                  padding: "10px", 
                  borderRadius: "8px", 
                  border: "1px solid #ccc", 
                  marginTop: "2px", 
                  marginBottom: "5px", 
                  cursor: loading ? "not-allowed" : "pointer",
                  background: loading ? "#f0f0f0" : "white"
                }}
              >
                <option value="trabajador">Trabajador</option>
                <option value="empleador">Empleador</option>
              </select>
              
              <button
                type="submit"
                disabled={loading} // Deshabilita el botón
                style={{
                  marginTop: "20px",
                  padding: "10px",
                  background: loading ? "#ccc" : "#00796B",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: loading ? "not-allowed" : "pointer",
                }}
              >
                {loading ? "Procesando..." : "Registrarse"}
              </button>
            </form>

            {error && (
              <p style={{ color: "red", textAlign: "center", fontWeight: "600", marginTop: "10px" }}>
                {error}
              </p>
            )}
          </>
        )}

        {!success && (
          <p style={{ textAlign: "center", marginTop: "15px" }}>
            ¿Ya tenés cuenta?{" "}
            <Link to="/login" style={{ color: "#00796B", fontWeight: "600" }}>
              Iniciar sesión
            </Link>
          </p>
        )}
      </motion.div>
    </div>
  );
}